import './AuthPageLayout.scss';
import loginImage from '../../assets/images/login-image-new.svg';
import subtractImage from '../../assets/images/subtract.svg';
import LangSwitcher from '../../component/langswitcher/LangSwitcher.jsx';
import { useTranslation } from 'react-i18next';

const AuthPageLayout = ({ children, className }) => {
  const { t } = useTranslation();
  return (
    <div className={`auth-page-container h-screen flex w-full bg-white ${className}`}>
      <div className='flex-1 flex flex-column p-6'>
        <div className='sidebar-header-container'>
          <div className="sidebar-header">
            <img className="subtract" src={subtractImage} />
            <div className="sidebar-header-text">{t('login.portalName')}</div>
          </div>
          <LangSwitcher showSeparator={false} noBorder={false} />
        </div>
        <div className='flex flex-column align-items-center justify-content-start mt-6'>
          <div className='w-11 sm:w-30rem'>
            {children}
          </div>
        </div>
      </div>
      <div
        className='hidden lg:flex flex-1 align-items-center justify-content-start bg-cover test'
        style={{ maxWidth: '50%', width: '50%', overflow: 'hidden' }}>
        <img src={loginImage} className='h-full' style={{ minHeight: '60rem' }} />
      </div>
    </div>
  );
};

export default AuthPageLayout; 